import { createStructuredSelector } from 'reselect';
import {
  titleDropDwonValues,
  suffixDropDownValues,
  phoneDropDownValues,
  emailDropDownValues,
  addressDropDownValues,
  stateDropDownValues,
  countryDropDownValues,
  genderDropDownValues
} from "../../../../selectors/globalSelectors";
import { zipCodeData } from '../../../../CommonComponents/Zipcode/selectors';

const getMyAccountStates = (data) => data.myAccount;

export const selectUpdateDone = state => {
  const { postInviteSuccess } = getMyAccountStates(state);
  return postInviteSuccess;
};

export const selectUpdateError = state => {
  const { isPostInviteError } = getMyAccountStates(state);
  return isPostInviteError;
};

export const iipDerivedStates = createStructuredSelector({
  titleDropDown: titleDropDwonValues,
  suffixDropDown: suffixDropDownValues,
  phoneDropDown: phoneDropDownValues,
  emailDropDown: emailDropDownValues,
  addressDropDown: addressDropDownValues,
  stateDropDown: stateDropDownValues,
  countryDropDown: countryDropDownValues,
  genderDropDown: genderDropDownValues,
  isSuccess: selectUpdateDone,
  zipCodeData: zipCodeData,
  isError: selectUpdateError
})